import { FaSquareFacebook, FaSquareInstagram, FaLinkedin, FaSquareTwitter, FaSquareYoutube } from "react-icons/fa6";
import { colors } from "../utils/colors";

export const Footer = () => {
    const links = [
        {
            title: "Locations",
            link: ""
        },
        {
            title: "Contact Us",
            link: ""
        },
        {
            title: "Help & Support",
            link: ""
        },
        {
            title: "Browse with Specialist",
            link: ""
        },
        {
            title: "Accessible Banking",
            link: ""
        },
        {
            title: "Security",
            link: ""
        },
        {
            title: "Online Banking Service Agreement",
            link: ""
        },
        {
            title: "Advertising Practices layer",
            link: ""
        },
        {
            title: "Your Privacy Choices",
            link: ""
        }
    ];
    return (
        <div className="footer-container">
            <div className="link-container">
                {links.map((x, i) => {
                    return (
                        <div className="link-button-containter">
                            <button key={`link-${i}`} className="link-button">
                                <p>{x.title}</p>
                            </button>

                            {i !== links.length - 1 && <p style={{ color: "white" }}>|</p>}
                        </div>
                    );
                })}
            </div>
            <div className="footer-socials">
                <p style={{ textAlign: "center", color: "white" }}>Connect With Us</p>
                <div className="social-media-container">
                    <button className="social-media-button">
                        <FaSquareFacebook size={40} color="white" />
                    </button>
                    <button className="social-media-button">
                        <FaSquareInstagram size={40} color="white" />
                    </button>
                    <button className="social-media-button">
                        <FaLinkedin size={40} color="white" />
                    </button>
                    <button className="social-media-button">
                        <FaSquareTwitter size={40} color="white" />
                    </button>
                    <button className="social-media-button">
                        <FaSquareYoutube size={40} color="white" />
                    </button>
                </div>
            </div>

            <div style={{ padding: "10px 0" }}>
                <p style={{ textAlign: "center", color: "white" }}>
                    Wells Cargo, N.A.{" "}
                    <a
                        style={{ color: colors.orange }}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://app.fullstory.com/ui/o-1X9HCN-na1/spaces/7Ptr7YDozNTM"
                    >
                        a Monotology Company{" "}
                    </a>{" "}
                    Member FDIC.{" "}
                </p>

                <p style={{ textAlign: "center", color: "white" }}>
                    © 2024 Wells Cargo Corporation. All rights reserved.
                </p>
            </div>
        </div>
    );
};
